module.exports = __webpack_public_path__ + "static/img/bg-left.c9bfe9a.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/bg-left.png
// module id = WC56
// module chunks = 1